
















import Vue from 'vue';
import JerseyLoading from '@/components/elements/JerseyLoading.vue';
import axios from 'axios';
import { Gender } from '../../common/api/Gender';
import GeneratorRequest from '../../common/api/IGeneratorRequest';
import GeneratorResponse from '../../common/api/IGeneratorResponse';

export default Vue.extend({
  name: 'GenerateBabyName',
  components: { JerseyLoading },
  mounted() {
    const firstName = this.$store.state.firstName;
    const lastName = this.$store.state.lastName;
    const gender = this.$store.state.gender.selected as string;

    const request: GeneratorRequest = {
      first: this.$store.state.firstName,
      last: this.$store.state.lastName,
      gender: getGender(gender),
    };

    axios
      .post(process.env.VUE_APP_SERVER_API, request, {
        // headers: { 'Access-Control-Allow-Origin': '*' },
      })
      .then((response: { data: GeneratorResponse }) => {
        document.location.href = response.data.redirect + '?createdBaby';
      })
      .catch((error: any) => {
        this.$store.commit('clear');
        // this.$store.commit('set_currentPage', 'Success');
      });
  },
});

function getGender(gender: string): Gender {
  return gender === 'boy'
    ? Gender.Male
    : gender === 'girl'
    ? Gender.Female
    : randomGender();
}

function randomGender(): Gender {
  return Math.random() > 0.5 ? Gender.Male : Gender.Female;
}
